import type { ValidationSchema } from './types';

let warned = false;

/**
 * Parse a validation_schema JSON text column into a typed ValidationSchema.
 * Returns null on missing, empty, invalid JSON, or unsupported version.
 */
export function parseValidationSchema(
  jsonText: string | null | undefined,
): ValidationSchema | null {
  if (jsonText == null || jsonText === '') return null;

  try {
    const parsed = JSON.parse(jsonText);
    if (typeof parsed !== 'object' || parsed === null) return null;
    if (parsed.version !== 1) {
      if (!warned) {
        console.warn('[validation] Unsupported validation_schema version:', parsed.version);
        warned = true;
      }
      return null;
    }
    if (typeof parsed.fields !== 'object' || parsed.fields === null) return null;
    return parsed as ValidationSchema;
  } catch {
    if (!warned) {
      console.warn('[validation] Invalid validation_schema JSON');
      warned = true;
    }
    return null;
  }
}
